/**
 * @author PoornaChandu
 * @description  Planned Hours for Device  is Scheduled
 */
import React, { useState, useEffect } from 'react';
import { Tag, DatePicker, Button, message, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { Option } = Select;

const DatePlannedHours = (props) => {
  const [inputTagVisible, setInputTagVisible] = useState(false);
  const [value, setValue] = useState(props.value || []);
  const [selectedDate, setSelectedDate] = useState(null);
  const [plannedHours, setPlannedHours] = useState(null);

  const { startDate, endDate } = props;

  useEffect(() => {
    if (props.value !== undefined) {
      setValue(props.value);
    } else {
      setValue([]);
    }
  }, [props.value]);

  const handleTagClick = () => {
    setInputTagVisible(!inputTagVisible);
  };

  const handleAddTag = () => {
    if (selectedDate && plannedHours >= 0 && plannedHours <= 24) {
      const formattedDate = selectedDate.format('YYYY-MM-DD');
      const newTag = `${formattedDate}: ${plannedHours} hours`;
      const newValue = [...value, newTag];
      setValue(newValue);
      props.addedTagList(formattedDate, plannedHours, selectedDate);
      setSelectedDate(null);
      setPlannedHours(null);
      setInputTagVisible(false);
    } else {
      message.warning('Please enter planned hours between 0 and 24.');
    }
  };

  const handleTagClose = (index) => {
    const newValue = [...value];
    newValue.splice(index, 1);
    setValue(newValue);
    props.closeTagList(newValue);
  };

  // Extract dates already used
  const usedDates = value.map((tag) => tag.split(':')[0]);

  const disabledDate = (current) => {
    const isBeforeStart = startDate && current.isBefore(dayjs(startDate), 'day');
    const isAfterEnd = endDate && current.isAfter(dayjs(endDate), 'day');
    const isUsed = usedDates.includes(current.format('YYYY-MM-DD'));

    return isBeforeStart || isAfterEnd || isUsed;
  };

  return (
    <div>
      <Tag onClick={(props?.formObject?.EditCount >= 2) || (props?.formObject.Status === 'Submitted') || props.disabled ? undefined : handleTagClick}
        style={{
          borderStyle: 'dashed',
          cursor: (props?.formObject?.EditCount >= 2) || (props?.formObject.Status === 'Submitted') ? 'not-allowed' : 'pointer',
          color: (props?.formObject?.EditCount >= 2) || (props?.formObject.Status === 'Submitted') ? 'rgba(250, 250, 250, 0.97)' : undefined,
          pointerEvents: (props?.formObject?.EditCount >= 2) || (props?.formObject.Status === 'Submitted') ? 'none' : 'auto',
        }}
      >
        <PlusOutlined /> Date Selection
      </Tag>

      {inputTagVisible && (
        <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 ,width:600}}>
          <DatePicker
          placeholder='select Date'
            disabledDate={disabledDate}
            value={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            style={{ marginRight: 8, width:200}}
          />

          <Select
          data-testid='plannedhoursday'
            value={plannedHours}
            onChange={(value) => setPlannedHours(value)}
            placeholder="Planned hrs Per Day"
            style={{ width: 230, marginRight: 8 }}
          >
            {Array.from({ length: 24 }, (_, i) => (
              <Option key={i + 1} value={i + 1}>
                {i + 1}
              </Option> 
            ))}
          </Select>

          <Button type="primary" onClick={handleAddTag}>
            Add
          </Button>
        </div>
      )}

      {value &&
        Array.isArray(value) &&
        value.map((tag, index) => {
          const isLongTag = tag.length > 20;
          return (
            <Tag
              color="blue"
              key={tag}
              closable={true}
              onClose={() => handleTagClose(index)}
              style={{ marginTop: 8 }}
            >
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </Tag>
          );
        })}
    </div>
  );
};

export default DatePlannedHours;
                                                                                                                                                                                                                                                                                                                                                